module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfABc4AMP6lbBP.a9f09954.woff2";